import sumBy from 'lodash/sumBy';

import { connectEditor } from '../connect-editor';
import { opsRoles } from '../constants';
import {
  getLinesForBusiness,
  getMaxEndDate,
  getMinStartDate,
  getSpentBudgetForBusiness,
} from '../utils';
import { filtersApplied } from '../utils/filter-utils';
import BusinessLine from './BusinessLine';

const mapStateToProps = (
  {
    campaignLinesById,
    campaign,
    campaignLineFilters,
    campaignUI: { expansionStateByLabel },
  },
  { label, products },
) => {
  const lines = getLinesForBusiness({ products }, campaignLinesById);
  const applicableRoles = opsRoles.filter(el => el.business === label);

  return {
    spendableBudget: sumBy(lines, 'spendableBudget'),
    spentBudget: getSpentBudgetForBusiness(campaign, lines),
    minStartDate: getMinStartDate(lines),
    maxEndDate: getMaxEndDate(lines),

    ops: applicableRoles.map(ops => ({ ...ops, value: campaign[ops.key] })),
    pspElement: campaign.pspElement,
    collabaryId: campaign.collabaryId,
    compact: filtersApplied(campaignLineFilters),
    expanded: expansionStateByLabel[label],
  };
};

export default connectEditor(mapStateToProps)(BusinessLine);
